import { createFeatureSelector, createSelector } from '@ngrx/store';
import { compressObjectToEncodedURIComponent } from 'src/app/shared/utils/compression.utils';
import { CustomerDPState } from './customer-dp.reducer';

export const getCustomerDPState = createFeatureSelector<CustomerDPState>('customerDP');

export const getCustomerDPError = createSelector(
  getCustomerDPState,
  (state: CustomerDPState) => state.error,
);

export const getRequestedBlendState = createSelector(
  getCustomerDPState,
  (state) => state.requestedBlendState,
);

export const getRequestedDna = createSelector(
  getRequestedBlendState,
  (blendState) => blendState && compressObjectToEncodedURIComponent(blendState),
);
